import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const conversationsSlice = createSlice({
  name: "conversations",
  initialState,
  reducers: {},
});

export default conversationsSlice.reducer;
